/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { KoreaStockProcessOrderInfoVo } from './KoreaStockProcessOrderInfoVo';
import {
    KoreaStockProcessOrderInfoVoFromJSON,
    KoreaStockProcessOrderInfoVoFromJSONTyped,
    KoreaStockProcessOrderInfoVoToJSON,
    KoreaStockProcessOrderInfoVoToJSONTyped,
} from './KoreaStockProcessOrderInfoVo';

/**
 * 
 * @export
 * @interface ResponseKoreaStockProcessOrderInfoVo
 */
export interface ResponseKoreaStockProcessOrderInfoVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseKoreaStockProcessOrderInfoVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseKoreaStockProcessOrderInfoVo
     */
    message?: string;
    /**
     * 
     * @type {KoreaStockProcessOrderInfoVo}
     * @memberof ResponseKoreaStockProcessOrderInfoVo
     */
    data?: KoreaStockProcessOrderInfoVo;
}

/**
 * Check if a given object implements the ResponseKoreaStockProcessOrderInfoVo interface.
 */
export function instanceOfResponseKoreaStockProcessOrderInfoVo(value: object): value is ResponseKoreaStockProcessOrderInfoVo {
    return true;
}

export function ResponseKoreaStockProcessOrderInfoVoFromJSON(json: any): ResponseKoreaStockProcessOrderInfoVo {
    return ResponseKoreaStockProcessOrderInfoVoFromJSONTyped(json, false);
}

export function ResponseKoreaStockProcessOrderInfoVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseKoreaStockProcessOrderInfoVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : KoreaStockProcessOrderInfoVoFromJSON(json['data']),
    };
}

export function ResponseKoreaStockProcessOrderInfoVoToJSON(json: any): ResponseKoreaStockProcessOrderInfoVo {
    return ResponseKoreaStockProcessOrderInfoVoToJSONTyped(json, false);
}

export function ResponseKoreaStockProcessOrderInfoVoToJSONTyped(value?: ResponseKoreaStockProcessOrderInfoVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': KoreaStockProcessOrderInfoVoToJSON(value['data']),
    };
}

